/* app/ui/social/social */

import $ from 'jquery';
import { Popup } from 'App/popup/popup';

var selectors = {
	popup: '.js-social-popup',
	print: '.js-print'
};

var dataAttributes = {
	width: 'data-social-width',
	height: 'data-social-height'
};

var module = {
	init: function () {
		module._initEvents();
	},

	_initEvents: function () {
		$(selectors.popup).on('click', module._processClick);
		$(selectors.print).on('click', module._showPrintWindow);
	},

	_processClick: function (event) {
		event.preventDefault();
		var $this = $(this);
		var width = $this.attr(dataAttributes.width) ? $this.attr(dataAttributes.width) : 550;
		var height = $this.attr(dataAttributes.height) ? $this.attr(dataAttributes.height) : 450;

		Popup.open(this.href, width, height);
	},

	_showPrintWindow: function (event) {
		event.preventDefault();

		window.print();
	}
};

export { module as Social };
